export type ObjectFields<T> = {
    [P in keyof T]: T[P];
};

export function stringified(val: any): string {
    return typeof (val) === 'string' ? val : val.toString();
}

export function strNullOrEmpty(str: string) {
    return str == null || str.trim() === '';
}

// export function sortByObjectKey(sortables: any[], primarySortKey: string , secondarySortKey: string ): any[] {
//     if (sortables == null || primarySortKey == null) {
//         return null;
//     }

//     if (secondarySortKey == null) {
//         sortables.sort((a, b) => (a[primarySortKey] > b[primarySortKey]) ? 1 : -1);
//     } else {
//         sortables.sort((a, b) => (a[primarySortKey] > b[primarySortKey]) ?
//             1 : (a[primarySortKey] === b[primarySortKey]) ? ((a[secondarySortKey] > b[secondarySortKey]) ? 1 : -1) : -1);
//     }

//     return sortables;
// }

export function sortByObjectDate(sortables: any[], primarySortKey: any, primarySortKeyAlt: any) {
    sortables.sort((a, b) => {
        // this sort preferences reverse-chron order... REVIST using params if sort-direction needs configurable
        const dateA = a[primarySortKey];
        const dateAAlt = a[primarySortKeyAlt];
        const dateB = b[primarySortKey];
        const dateBAlt = b[primarySortKeyAlt];

        const useDateA = dateA == null ? dateAAlt : dateA;
        const useDateB = dateB == null ? dateBAlt : dateB;

        const compare = new Date(useDateB).getTime() > new Date(useDateA).getTime() ? 1 : -1;
        // console.log('compare = ' + compare);
        return compare;
    });

    return sortables;
}

export function recordDate(): string {
    return new Date().toJSON();
}

export function jsonEqual(a: any, b: any): boolean {
    return JSON.stringify(a) === JSON.stringify(b);
}

export function objPropEqual(objA: any, objB: any, propName: string): boolean {
    return objA[propName] === objB[propName];
}

export function deepCloneByJson(object: any): any {
    return JSON.parse(JSON.stringify(object));
}

export function chunkArrayBySize(arr: any, size: any) {
    var chunked = [];
    for (var i = 0; i < arr.length; i += size) {
        chunked.push(arr.slice(i, i + size));
    }
    return chunked;
}

export function getEnumKeyNames(e: any) {
    return Object.keys(e).filter(k =>
        typeof e[k] === "number"
        || e[k] === k
        || e[e[k]]?.toString() !== k
    );
}

// `PropertyKey` is short for "string | number | symbol"
// since an object key can be any of those types, our key can too
// in TS 3.0+, putting just "string" raises an error
export function hasKey<O extends object>(obj: O, key: PropertyKey): key is keyof O {
    return key in obj
}